<div class="d-flex justify-content-center align-items-center" style="min-height: 60vh;">
    <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
</div>
